import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function RouteScrollReset() {
  const { pathname, search, hash, key } = useLocation();

  useLayoutEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => { window.history.scrollRestoration = previous; };
  }, []);

  useLayoutEffect(() => {
    // Acheter owns its catalog, filters and cart destinations after rendering.
    if (pathname.replace(/\/+$/, "") === "/market/acheter") return undefined;

    // Instant also overrides the site's CSS smooth scrolling on page changes.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    if (!hash) return undefined;

    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return undefined; }
    const scrollToAnchor = () => {
      const target = document.getElementById(id);
      if (!target) return false;
      target.scrollIntoView({ block: "start", behavior: "instant" });
      return true;
    };
    if (scrollToAnchor()) return undefined;

    // A destination can arrive later through a lazy route or an API response.
    const observer = new MutationObserver(() => {
      if (scrollToAnchor()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [pathname, search, hash, key]);

  return null;
}
